import React from "react";
import { NavLink } from "react-router-dom";

const Breadcrumbs = (props) => {
  return (
    <nav aria-label="breadcrumb" className="pt-1 pb-1" style={ {height: "30px"}}>
      <ol className="breadcrumb">
        {props.breadcrumbs.map((item, inx) => {
          if (inx == props.breadcrumbs.length - 1) {
            return (
              <li key={inx} className="breadcrumb-item active text-success" aria-current="page" onClick={item.onClick}>
                {item.label}
              </li>
            );
          } else {
            return (
              <li key={inx} className="breadcrumb-item" onClick={item.onClick}>
                {props.isEditMode
                ?
                  <NavLink to="#">{item.label}</NavLink>
                :
                  <NavLink to={`${item.url}`}>{item.label}</NavLink>
                }
              </li>
            );
          }
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
